import css from './SectionCars.module.css';

const SectionCars = ({ blocks }) => {
  return (
    <section className={css.cars_wrapper}>
      <div className={css.cars}>
        <ul>
          {blocks.map(car => {
            return (
              <a key={car.blockName} href={car.media.link.href}>
                <li>
                  <img
                    className={css.car_img}
                    src={car.media.image.attributes.variants.landscape400.url}
                  />
                  <p className={css.car_name}>{car.blockName}</p>
                </li>
              </a>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default SectionCars;
